import styled from 'styled-components';

export const Container = styled.main`
  min-height: 100vh;
  width: calc(100vw - 64px);
  margin: 0 0 0 64px;
  padding: 32px;
  color: var(--cco-ink);
  background: var(--cco-bg);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 720px) {
    width: 100vw;
    margin: 0;
    padding: 20px 16px 88px;
  }
`;

export const Header = styled.header`
  width: 100%;
  max-width: 1280px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--cco-line);

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cco-blue);
  margin-bottom: 8px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 32px;
  line-height: 1.1;
  color: var(--cco-ink);
`;

export const Description = styled.p`
  margin: 10px 0 0;
  max-width: 760px;
  color: var(--cco-ink-mute);
  font-size: 14px;
  line-height: 1.6;
`;

export const PlatformTabs = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;

  a {
    border: 1px solid var(--cco-line);
    background: var(--cco-surface);
    color: var(--cco-ink-mute);
    border-radius: 999px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    transition: border-color 150ms ease, background 150ms ease,
      color 150ms ease;
  }

  a:hover,
  a.active {
    border-color: var(--cco-blue);
    background: var(--cco-blue);
    color: #fff;
  }
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(96px, 1fr));
  gap: 8px;
  min-width: 320px;

  @media (max-width: 520px) {
    width: 100%;
    min-width: 0;
    grid-template-columns: 1fr;
  }
`;

export const Stat = styled.div`
  border: 1px solid var(--cco-line);
  background: var(--cco-surface);
  border-radius: 8px;
  padding: 12px;

  small {
    display: block;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--cco-ink-mute);
  }

  strong {
    display: block;
    margin-top: 6px;
    font-size: 20px;
    color: var(--cco-ink);
  }
`;

export const Filters = styled.div`
  width: 100%;
  max-width: 1280px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 20px 0;
`;

export const FilterButton = styled.button`
  border: 1px solid
    ${(props) => (props.$active ? 'var(--cco-blue)' : 'var(--cco-line)')};
  background: ${(props) => (props.$active ? 'var(--cco-blue)' : 'var(--cco-surface)')};
  color: ${(props) => (props.$active ? '#fff' : 'var(--cco-ink-mute)')};
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;

  &:hover {
    color: ${(props) => (props.$active ? '#fff' : 'var(--cco-ink)')};
    border-color: var(--cco-blue);
  }
`;

export const Timeline = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 1280px;
`;

export const Release = styled.article`
  border: 1px solid var(--cco-line);
  background: var(--cco-surface);
  border-radius: 8px;
  overflow: hidden;
`;

export const ReleaseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--cco-line);

  h2 {
    margin: 0;
    font-size: 20px;
    color: var(--cco-ink);
  }

  time {
    color: var(--cco-ink-mute);
    font-size: 12px;
    white-space: nowrap;
  }
`;

export const GroupGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1px;
  background: var(--cco-line);
`;

export const Group = styled.div`
  background: var(--cco-surface);
  padding: 18px 20px;

  h3 {
    margin: 0 0 12px;
    font-size: 12px;
    color: var(--cco-blue);
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    color: var(--cco-ink-mute);
    font-size: 13px;
    line-height: 1.55;
  }

  li + li {
    margin-top: 8px;
  }

  strong {
    color: var(--cco-ink);
  }
`;

export const Empty = styled.div`
  border: 1px solid var(--cco-line);
  background: var(--cco-surface);
  border-radius: 8px;
  padding: 24px;
  color: var(--cco-ink-mute);
`;
